<section class="mx-3">
  <div class="organization-details">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="page_header">
        <h3 class="m-0 page_header_title">{{OrganizationData?.description | translatepipe}}</h3>
      </div>
      <div class="add-sub-organization">
        <button mat-raised-button color="primary" class="px-5 add_button" (click)="openDialog()" translate>
          + Add Sub Organisation
        </button>
      </div>
    </div>
    <div class="organization-info-card text-invert-color p-4">
      <div class="card-header">
        <div class="organization-header">
          <h3 class="m-0 organization-name">{{OrganizationData?.organization_name }}</h3>
          <p class="organization-location">{{OrganizationData?.city }}</p>
        </div>
        <!-- <button mat-icon-button class="options-menu">
          <i class="fa-solid fa-ellipsis-vertical"></i>
        </button> -->
      </div>
      <div class="contact-info">
        <div class="contact-item">
          <div class="contact-item-icon">
            <i class="fa-solid fa-phone"></i>
          </div>
          <div class="d-block">
            <p class="m-0" translate>Contact</p>
            <p class="m-0">{{OrganizationData?.employee_phone_number ? OrganizationData?.employee_phone_number : '-' }}</p>
          </div>
        </div>
        <div class="contact-item">
          <div class="contact-item-icon">
            <i class="fa-solid fa-envelope"></i>
          </div>
          <div class="d-block">
            <p class="m-0" translate>Email</p>
            <p class="m-0">{{OrganizationData?.email ? OrganizationData?.email : '-' }}</p>
          </div>
        </div>
        <div class="contact-item">
          <div class="contact-item-icon">
            <i class="fa-solid fa-location-dot"></i>
          </div>
          <div class="d-block">
            <p class="m-0">{{OrganizationData?.address_line1 }}</p>
            <p style="margin-bottom: 0px;">
              {{OrganizationData?.address_line2 }},{{OrganizationData?.city | translatepipe}},{{OrganizationData?.state_name }}{{OrganizationData?.pincode }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <h3 class="sub-organization-title mt-4" translate>Sub-Organisation Details</h3>
  <div class="table-container mt-2">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="Sl_No">
        <th mat-header-cell *matHeaderCellDef translate>Sl.No</th>
        <td mat-cell *matCellDef="let element; let i = index;">{{ i+1 }}</td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef translate>Name</th>
        <td mat-cell *matCellDef="let element">
          {{ element.sub_organization_name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef translate>Code</th>
        <td mat-cell *matCellDef="let element">
          {{ element.sub_organization_code }}
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef translate>Email</th>
        <td mat-cell *matCellDef="let element">
          {{ element.email }}
        </td>
      </ng-container>

      <ng-container matColumnDef="contact_number">
        <th mat-header-cell *matHeaderCellDef translate>Contact Number</th>
        <td mat-cell *matCellDef="let element">{{ element.contact_number }}</td>
      </ng-container>

      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef translate>Location</th>
        <td mat-cell *matCellDef="let element">{{ element.city }}</td>
      </ng-container>

      <!-- <ng-container matColumnDef="point_of_contact">
        <th mat-header-cell *matHeaderCellDef>Point Of Contact</th>
        <td mat-cell *matCellDef="let element">
          {{ element.designation }}
        </td>
      </ng-container> -->

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef translate>Actions</th>
        <td mat-cell *matCellDef="let element; let i = index;">
          <div class="action_button" [matMenuTriggerFor]="menu" aria-label="Actions">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <mat-menu #menu="matMenu">
            <!-- <button class="update_button" mat-menu-item (click)="openSubOrgView(i)"><span>View</span>
            </button> -->
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="selection.toggle(row)"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4" translate>No data</td>
      </tr>
    </table>
  </div>
  <ng-template #addForm>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <div>
        <h4 class="m-0" translate>Leave Type</h4>
      </div>
      <div>
        <button mat-raised-button color="primary" (click)="showadd()" class="px-5" translate>Back</button>
      </div>
    </div>
    <div class="container">
      <form [formGroup]="form">
        <div class="row">
          <div *ngFor="let question of questions" class="col-sm-6">
            <app-question [question]="question" [form]="form"></app-question>
          </div>
        </div>
        <div class="form-row">
          <button mat-raised-button color="primary" class="px-5 submit_button" type="submit" [disabled]="!form.valid" translate>
            Submit
          </button>
        </div>
      </form>
      <!-- <div *ngIf="payLoad" class="form-row">
          <strong>Saved the following values</strong><br>{{payLoad}}
        </div> -->
    </div>
  </ng-template>
</section>